import Auth0Authenticate, {
  navigationGuard,
  getCurrentUser
} from "./auth0-authenticate";

export default Auth0Authenticate;
export { navigationGuard, getCurrentUser };
